"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Routing = require("Functions/Routing");
var _numeral = _interopRequireDefault(require("numeral"));
var _moment = _interopRequireDefault(require("moment"));
var _Link = _interopRequireDefault(require("Pure/Link"));
const ProjectRow = (_ref, props) => {
  let {
    data,
    blank = false,
    fields
  } = _ref;
  _numeral.default.locale('en');
  _moment.default.locale('fr');
  const role = app.state.session.user.roles[0];
  const praticianInfos = data.__user;
  const blank_props = blank === true ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  const link = /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({
    className: "u-link-only"
  }, blank_props, {
    href: (0, _Routing.URL)('AdminProjectsDashboard') + '/' + data.id
  }), "Fiche de l'utilisateur");
  const formatedDate = (0, _moment.default)(data.surgery_date).format('LL');
  let projectStatus = "";
  let statusClass = undefined;
  const screenWidth = window.screen.width;
  switch (data.project_status) {
    case 'open':
      (projectStatus = "Ouvert") && (statusClass = "project_infos__status-open");
      break;
    case 'running':
      (projectStatus = "En cours") && (statusClass = "project_infos__status-running");
      break;
    case 'pending':
      (projectStatus = "En attente") && (statusClass = "project_infos__status-pending");
      break;
    case 'over':
      (projectStatus = "Terminé") && (statusClass = "project_infos__status-over");
      break;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__row " + statusClass
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell"
  }, role === "deltex" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.record_number, link) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.patient_firstname + ' ' + data.patient_lastname, link)), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell"
  }, formatedDate, link), screenWidth > 1200 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell"
  }, data.stl_type, link), role === "pratician" ? undefined : /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell"
  }, praticianInfos === null || praticianInfos === void 0 ? void 0 : praticianInfos.firstname, " ", praticianInfos === null || praticianInfos === void 0 ? void 0 : praticianInfos.name)) : undefined);
};
var _default = exports.default = ProjectRow;
